module.exports = __webpack_public_path__ + "assets/img/checked.5a15bd2c.svg";